import type { UseQueryResult } from '@tanstack/react-query'

import type { CompanyOption } from '../types/catalog'
import { toCompanyOptions } from '../utils/companyMappers'
import { useCompaniesQuery } from './useCompaniesQuery'

export function useCompanyOptionsQuery(): UseQueryResult<CompanyOption[]> {
  return useCompaniesQuery({ select: toCompanyOptions })
}
